import Vue from "vue";
import vSelect from "vue-select";
import ServiceDefaultName from "@/api/Services/ServiceDefaultName";
import "vue-select/dist/vue-select.css";

import { bus } from "@/main";
import { Component, Watch } from "vue-property-decorator";
import { ServiceDefaultNameInterface } from "@/api/Interfaces/ServiceDefaultNameInterface";
import { ResponseInterface } from "@/api/Interfaces/ResponseInterface";
import MobileFacade from "@/facades/MobileFacade";

const SelectServiceDefaultNamesProps = Vue.extend({
  props: {
    selectedServiceDefaultName: {
      type: [Object as () => ServiceDefaultNameInterface],
      default: null,
    },
    placeholderTextDesktop: {
      type: String,
      default: "Pesquise um novo serviço",
    },
    placeholderTextMobile: {
      type: String,
      default: "Pesquise um novo serviço",
    },
    logo: {
      type: String,
      default: require("@/assets/images/logo_clinicarx.webp"),
    },
    iframeMode: {
      type: Boolean,
      default: false
    }
  },
});

@Component({
  name: "SelectServiceDefaultNames",
  components: {
    "v-select": vSelect,
  },
})
export default class SelectServiceDefaultNames extends SelectServiceDefaultNamesProps {
  cx_ServiceDefaultNames: Array<ServiceDefaultNameInterface> = [];
  cx_searchText: string | null = null;
  cx_logo: string = this.logo;
  cx_selectedServiceDefaultName = this.selectedServiceDefaultName;
  cx_isOpenMobileModal = false;

  //Variaveis para controle do dropdown
  cx_dropdownOpen = false;
  cx_iframeMode = this.iframeMode;
  cx_isMobile = MobileFacade.isMobile();
  cx_blockInput = true;
  cx_inputBlurEl: any = null;
  cx_searchFocus = false;

  @Watch("selectedServiceDefaultName")
  public watchSelectedServiceDefaultName(newValue: ServiceDefaultNameInterface): void {
    this.cx_selectedServiceDefaultName = newValue;
  }

  mounted(): void {
    this.getServicesDefaultNames();
    this.cx_inputBlurEl = this.$refs.inputBlur as HTMLElement;
  }

  getServicesDefaultNames(): void {
    ServiceDefaultName.listWithAverage()
      .then((response) => {
        const responseData = response.data as ResponseInterface;
        this.cx_ServiceDefaultNames = responseData.data;
      })
      .finally(() => {
        bus.$emit("showLoading", false);
      });
  }

  toogleSearchModal($event: any = null): void {
    this.cx_searchText = "";

    if ($event != null) {
      $event.target.blur();
    }

    this.cx_isOpenMobileModal = !this.cx_isOpenMobileModal;
  }

  filterServiceDefaultNames(): Array<ServiceDefaultNameInterface> {
    const text = this.cx_searchText ?? "";

    if (text == "") return this.cx_ServiceDefaultNames;

    const regex = new RegExp(text, "gi");
    return this.cx_ServiceDefaultNames.filter((el) => {
      return el.name.match(regex) != null;
    });
  }

  selectServiceDefaultName(serviceDefaultName: ServiceDefaultNameInterface): void {
    this.cx_selectedServiceDefaultName = serviceDefaultName;
    this.$emit("changeServiceDefaultName", this.cx_selectedServiceDefaultName);
    this.toogleSearchModal();
  }

  formatCurrency(str: string): string {
    return parseFloat(str).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  returnHome() {
    if (this.$route.name == "SearchServicesTenancy" || this.$route.name == "Tenancy") {
      this.$router.push({ name: "Tenancy" });
    } else {
      this.$router.push({ name: "Home" });
    }
  }

  // Funções para controle do dropdown

  blurSelect() {
    this.toggleDropdown(false);
  }

  vselectSearchFocus() {
    this.cx_searchFocus = true;
    this.toggleDropdown(true, false);
  }

  vselectSearchBlur() {
    this.cx_searchFocus = false;
    this.toggleDropdown(false);
  }

  changeSelect() {
    this.toggleDropdown(false); 
    this.$emit('changeServiceDefaultName', this.cx_selectedServiceDefaultName);
  }

  toggleDropdown(state: boolean, toggleInput = true): void {
    this.cx_blockInput = !state;
    this.cx_dropdownOpen = state;

    if (toggleInput) {
      this.toggleInputBlur(state);
    }
  }

  toggleInputBlur(dropdownState: boolean): void {
    if (dropdownState) {
      this.cx_inputBlurEl.focus();
    }
  }

  dropdownShouldOpen(): boolean {
    return this.cx_dropdownOpen;
  }

  blockFrameClick() {
    this.toggleDropdown(true);
  }
}
